<template>
  <div>
    <div class="titulo-aba">Comparativo de dados</div>
    <v-data-table :headers="headers" :items="itens" item-key="id" />
  </div>
</template>

<script>
export default {
  props: {
    refresh: Function,
    analises: Array
  },
  data() {
    return {
      headers: [
        { text: 'Dado', value: 'dadoComparacao' },
        { text: 'Preenchido', value: 'dadoPreenchido' },
        { text: 'Consultado', value: 'dadoConsultado' },
        { text: 'Comparativo', value: 'comparativoBureau' },
      ],
      itens: [],
      indicadorComparativo: null
    }
  },
  methods: {
    alimentarObjeto() {
      const th = this
      th.itens= []
      if(th.analises.length === 0)
        return;

      th.itens = JSON.parse(JSON.stringify(th.analises));
      th.itens.forEach(curr => th.normalizarCampos(curr))
    },
    normalizarCampos(curr) {
      const th = this

      curr.dadoPreenchido = curr.dadoPreenchido ? curr.dadoPreenchido.toUpperCase() : curr.dadoPreenchido;
      curr.dadoConsultado = curr.dadoConsultado ? curr.dadoConsultado.toUpperCase() : curr.dadoConsultado;

      if (curr.dadoComparacao === 'Data de nascimento' || curr.dadoComparacao === 'Data de abertura') {
        curr.dadoPreenchido = th.formatarData(curr.dadoPreenchido)
        curr.dadoConsultado = th.formatarData(curr.dadoConsultado)
      }

      if (curr.comparativoBureau === th.$api.Arrays.ComparativoBureau.find((x) => x.text === 'Conforme').value)
        th.indicadorComparativo = '🟢 '
      else if (curr.comparativoBureau === th.$api.Arrays.ComparativoBureau.find((x) => x.text === 'Não conforme').value)
        th.indicadorComparativo = '🔴 '
      else if (curr.comparativoBureau === th.$api.Arrays.ComparativoBureau.find((x) => x.text === 'Menor de 18 anos').value)
        th.indicadorComparativo = '🟠 '

      curr.comparativoBureau = th.indicadorComparativo + (curr.mensagem === '' || curr.mensagem === null ? th.$api.Arrays.ComparativoBureau.find((x) => x.value === curr.comparativoBureau).text : curr.mensagem)
    },
    formatarData(value) {
      if (!value) return value;

      const regexBR = /^(0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
      const regexISOData = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
      const regexISOComHora = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])T.+$/;

      const dataString = value.trim();
      let data;

      if (regexBR.test(dataString)) {
        const [dia, mes, ano] = dataString.split('/');
        data = new Date(ano, mes - 1, dia);
      } else if (regexISOData.test(dataString)) {
        const [ano, mes, dia] = dataString.split('-');
        data = new Date(ano, mes - 1, dia);
      } else if (regexISOComHora.test(dataString)) {
        data = new Date(dataString);
      } else {
        const parsed = Date.parse(dataString);
        if (!isNaN(parsed)) {
          data = new Date(parsed);
        } else {
          return value;
        }
      }

      return new Intl.DateTimeFormat('pt-BR').format(data);
    }
  }
}
</script>
